export default "__VITE_ASSET__B9_7o3Qi__"